export default {
  title: 'Voici ce qui se passe',
  kpis: {
    title: 'Widgets KPI',
    dashboard: 'Tableau de bord',
    reports: 'Rapports',
    expandButton: 'KPIs',
    deleteKPI: 'Faites glisser les Kpis ici pour les supprimer de l\'affichage',
    dragKPI: 'Faites glisser le KPI où vous souhaitez le voir dans le tableau de bord',
    noAdditionalKPIs: 'Il n\'y a pas de KPI supplémentaires à afficher',
    addKPIButton: 'Ajouter un KPI',
    removeKPIButton: 'Supprimer le KPI',
    customerFeedbackKPI: {
      title: 'Commentaires des clients'
    },
    activeDispatchesKPI: {
      title: 'Dépêches actives',
      scheduled: 'Programmé',
      onTime: 'À temps',
      delayed: 'Retardé'
    },
    providerAvailabilityKPI: {
      title: 'Disponibilité du fournisseur',
      active: 'Actif',
      inActive: 'Inactif',
      idle: 'Attendre'
    },
    scheduledDispatchesKPI: {
      title: 'Expéditions programmées',
      today: 'Aujourd\'hui',
      tomorrow: 'Demain',
      nextXDays: 'Suivant 7 jours'
    },
    onTimeDispatchesKPI: {
      title: 'Expéditions à temps',
      subTitle: 'Aujourd\'hui'
    },
    dispatchTypesKPI: {
      title: 'Types d\'expédition',
      subTitle: 'Aujourd\'hui',
      pickUp: 'Récupérer',
      dropOff: 'Déposer'
    },
    dispatchMethodsKPI: {
      title: 'Méthodes d\'expédition',
      subTitle: 'Aujourd\'hui',
      valet: 'Valet',
      shuttle: 'Navette',
      loaner: 'Prêteur',
      rideShare: 'Covoiturage'
    },
    dispatchTotalsKPI: {
      title: 'Totaux d\'expédition',
      subTitle: 'Aujourd\'hui',
      inProgress: 'En cours',
      complete: 'Compléter',
      cancelled: 'Annulé'
    }
  },
  providerLocations: {
    title: 'Emplacements des fournisseurs'
  },
  activeProviders: {
    title: 'Fournisseurs actifs',
    dispatches: 'expédié aujourd\'hui'
  }
};
